module.exports = __webpack_public_path__ + "img/personal16.90bbbed3.png";